


























import { Vue, Component, Prop} from 'vue-property-decorator';
import {CardConfig, CardStatus} from "@/types/ReservationCardConfig";

@Component
export default class ReservationCard extends Vue {

  @Prop({
    type: Object,
    default: {
      path: '',
      class: CardStatus.Loading,
      day: {
        withDay: true,
        number: '',
        text: '',
        isCurrentDay: true,
      },
      name: '',
      hours: {
        start: '',
        end: '',
      },
      owner: '',
    }
  })
  // @ts-ignore
  public config: CardConfig;

}

